"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgBannerComponent = void 0;
const Flex_1 = __importDefault(require("@targetx/mineral-ui/Flex"));
const Text_1 = __importDefault(require("@targetx/mineral-ui/Text"));
const react_1 = __importDefault(require("react"));
const theme_1 = __importDefault(require("../../theme"));
const OrgBannerComponent_copyText_1 = __importDefault(require("./OrgBannerComponent.copyText"));
function OrgBannerComponent({ org }) {
    return (react_1.default.createElement(Flex_1.default, { direction: "column", alignItems: "center", marginBottom: theme_1.default.space_stack_lg },
        react_1.default.createElement(Text_1.default, { fontSize: "1.2rem", fontWeight: "semiBold" }, org.name),
        react_1.default.createElement(Text_1.default, { fontFamily: "monospace" },
            "(",
            OrgBannerComponent_copyText_1.default.sidLabel,
            ": ",
            org.sid,
            ")")));
}
exports.OrgBannerComponent = OrgBannerComponent;
exports.default = OrgBannerComponent;
